import { Injectable } from '@angular/core';
import codes from 'country-calling-code';

@Injectable({
    'providedIn': 'root'
})
export class PhoneService {
    public getPhoneInfo(countryCode: string): any {
        // TODO ok check is works as expected
        const info = codes.find((item) => item.isoCode2 === countryCode);

        let phoneInfo = {
            'countryName': 'unknown',
            'phonePrefixes': ['unknown'],
            'countryCode': countryCode,
            'countryAbbr': 'unknown'
        };

        if (info) {
            phoneInfo = {
                'countryName': info?.country,
                'phonePrefixes': info?.countryCodes,
                'countryCode': info?.isoCode2,
                'countryAbbr': info?.isoCode3
            };
        }

        return phoneInfo;
    }
}
